import React from 'react';
import cn from 'classnames';
import { IResultsData } from '@pro/activity/testerClub/interface';
import { useTrans } from 'base/utils/i18n';
import styles from './index.module.less';

type IProps = {
    className?: string;
    resultsData?: IResultsData
}
const TopInfo: React.FC<IProps> = (props) => {
    const { t } = useTrans();
    const { className, resultsData } = props

    return(
        <div className={cn(styles['top-info'],className, 'flex')}>
            <div className={'g-item'}>
                <div className={'g-count'}>{resultsData?.points}</div>
                <span className={'g-text'}>{t('web_common_points')}</span>
            </div>

            <div className={cn('g-item')}>
                <div className={'g-count'}>{resultsData?.applicants}</div>
                <span className={'g-text'}>{t('web_shop_activity_applicants')}</span>
            </div>

            <div className={cn('g-item')}>
                <div className={'g-count'}>{resultsData?.num}</div>
                <span className={'g-text'}>{t('web_shop_activity_units_available')}</span>
            </div>
        </div>
    );
};

export default TopInfo